<template>
  <div class="ProductionCategoryList">
    <AppHeader>
      <el-page-header @back="goBack" content="课包分类管理">
      </el-page-header>
    </AppHeader>
    <AppBox class="appBox" id="appBox">
      <div class="tableFilter">
        <el-form :inline="true" :model="filter" size="small" ref="form">
          <el-form-item label="课包发布状态:" prop="category">
            <el-select
                v-model="filter.deployed"
                filterable
                placeholder="请选择"
                style="width: 100px"
                @change="onSubmit"
            >
              <el-option
                  v-for="item in deployStates"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查找</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
        <div style="text-align: right">
          <el-button type="primary" @click="openAddProductionCategory" plain
                     v-show="permissionCode.has('research:product:manager')"
          >新增分类
          </el-button>
        </div>
      </div>
      <XTable
          :api="getProductCategoryList"
          :state="{data:productCategoryList}"
          :columns="columns"
          :loading="productCategoryListLoading"
          :tableSize="tableSize"
          :maxHeight="maxHeight"
          :layout="layout"
      ></XTable>
    </AppBox>
    <AddProductionCategory ref="addProductionCategory"></AddProductionCategory>
  </div>
</template>

<script>
import XTable from "@/components/XTable/index.vue";
import {mapActions, mapState} from "vuex";
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppBox from "@/components/ui/AppBox/index.vue";
import AddProductionCategory from "@/pages/ProductionManagement/AddProductCategory.vue";

export default {
  name: "ProductionCategoryList",
  components: {AddProductionCategory, AppBox, AppHeader, XTable},
  props: {
    maxHeight: {
      type: Number,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      tableSize: "small",
      layout: "",
      deployStates: [
        {
          id: null,
          name: "全部"
        },
        {
          id: true,
          name: "已上架"
        },
        {
          id: false,
          name: "已下架"
        }
      ]
    };
  },
  computed: {
    ...mapState("teachingCenter", [
      "productCategoryList",
      "productCategoryListLoading",
    ]),
    ...mapState("user", ["permissionCode"]),
    filter: {
      get() {
        return this.$store.state.teachingCenter.productCategoryListFilter;
      },
      set(value) {
        this.$store.commit("teachingCenter/setData", {
          key: "productCategoryListFilter",
          value,
        });
      },
    },
    columns: function () {
      const self = this;
      const columns = [
        {
          prop: "name",
          label: "课包分类",
        },
        {
          prop: "size",
          width: 150,
          label: "显示课包数",
        },
        {
          prop: "deployed",
          width: 150,
          label: "状态",
          render(h, scope) {
            return (
                <div>
                  <span>{scope.row.deployed ? "已上架" : "已下架"}</span>
                </div>
            );
          },
        },
      ];
      if (this.permissionCode.has('research:product:manager')) {
        let listLength = this.productCategoryList.length;
        columns.push({
          label: "调整顺序",
          render(h, scope) {
            return (
                <div>
                  <el-button
                      onClick={() => {
                        self.handleUp(scope);
                      }}
                      disabled={scope.$index === 0}
                      size="mini"
                      type="primary"
                      plain
                  >
                    上移
                  </el-button>
                  <el-button
                      onClick={() => {
                        self.handleDown(scope);
                      }}
                      disabled={listLength === scope.$index + 1}
                      size="mini"
                      type="primary"
                      plain
                  >
                    下移
                  </el-button>
                </div>
            );
          }
        });
        columns.push({
          label: "操作",
          fixed:
              "right",
          width:
              250,
          render(h, scope) {
            return (
                <div>
                  {scope.row.deployed && (
                      <el-button
                          onClick={() => {
                            self.handleDeployProductCategory(scope.row);
                          }}
                          size="mini"
                          type="primary"
                          plain
                      >
                        下架
                      </el-button>
                  )}
                  {!scope.row.deployed && (
                      <el-button
                          onClick={() => {
                            self.handleDeployProductCategory(scope.row);
                          }}
                          size="mini"
                          type="primary"
                          plain
                      >
                        上架
                      </el-button>
                  )}
                  <el-button
                      onClick={() => {
                        self.handleEdit(scope.row);
                      }}
                      size="mini"
                      type="primary"
                      plain
                  >
                    编辑
                  </el-button>
                  <el-button
                      onClick={() => {
                        self.handleDelete(scope.row);
                      }}
                      disabled={scope.row.deployed}
                      size="mini"
                      type="danger"
                      plain
                  >
                    删除
                  </el-button>
                </div>
            );
          }
          ,
        });
      }
      return columns;
    }
  },
  async mounted() {
  },
  methods: {
    ...mapActions("teachingCenter", ["getProductCategoryList", "deleteProductCategory", "deployProductCategory", "moveProductCategory"]),
    // 搜索
    onSubmit() {
      this.getProductCategoryList({});
    },
    //重置
    onReset() {
      this.filter = {};
      this.getProductCategoryList({});
    },
    // 上移
    async handleUp(scope) {
      await this.moveFun(true, scope);
    },
    // 下移
    async handleDown(scope) {
      await this.moveFun(false, scope);
    },
    // 移动方法
    async moveFun(previewDirect, scope) {
      const offset = scope.$index + 1;
      this.move;
      await this.moveProductCategory({
        previewDirect: previewDirect,
        offset: offset,
        step: 1,
      }).then(() => {
        this.getProductCategoryList({})
      });
    },
    handleEdit(row) {
      this.openAddProductionCategory(row);
    },
    openAddProductionCategory(data) {
      this.$refs.addProductionCategory.initData(data);
      this.$refs.addProductionCategory.visible = true;
    },
    handleDelete(row) {
      this.$confirm("删除分类后不可找回,请确认是否继续删除!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      }).then(async () => {
        await this.deleteProductCategory(row.id);
        await this.getProductCategoryList({});
      });
    },
    async handleDeployProductCategory(row) {
      await this.deployProductCategory(row.id);
      await this.getProductCategoryList({});
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.ProductionCategoryList {

  .appBox {
    height: calc(100vh - 155px);
    min-height: 330px;

    .tableFilter {
      padding-bottom: 10px;
    }

    .el-form-item {
      margin-right: 20px;
    }

    ::v-deep .el-range-separator {
      width: 20px !important;
    }

    ::v-deep .el-tabs__item {
      color: #ff7918;
      padding: 0 30px 50px 30px;
      margin-left: 30px;
    }

    ::v-deep .el-tabs__item.is-active {
      background-color: #ff7918;
      padding: 0 30px;
      border-radius: 10px;
      color: #ffffff;
      margin-left: 30px;
    }

    ::v-deep .el-tabs__active-bar {
      margin-top: 10px;
      background-color: #e4e7ed;
    }
  }

}
</style>
